import type { OnboardingData } from '../../src/types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787';

export class OnboardingAPI {
  static async startSession(sourceSite: string): Promise<{ session_id: string; current_step: number }> {
    const response = await fetch(`${API_BASE_URL}/onboarding/start`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ source_site: sourceSite })
    });

    if (!response.ok) {
      throw new Error('Failed to start session');
    }

    return response.json();
  }

  static async updateStep(
    sessionId: string,
    step: number,
    data: Partial<OnboardingData>
  ): Promise<{ success: boolean; next_step: number }> {
    const response = await fetch(`${API_BASE_URL}/onboarding/step`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        session_id: sessionId,
        step,
        data
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update step');
    }

    return response.json();
  }

  static async complete(
    sessionId: string,
    data: OnboardingData
  ): Promise<{ success: boolean; lead_id: string; message: string }> {
    const response = await fetch(`${API_BASE_URL}/onboarding/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        session_id: sessionId,
        data
      })
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Failed to complete onboarding: ${error}`);
    }

    return response.json();
  }
}
